export const analyticsText = {
  title: 'Analytics',
  courses: 'Courses',
  coursesOverview: 'Courses overview',
  completed: 'Completed',
  inProgress: 'In progress',
  notStarted: 'Not started',
  passed: 'Passed',
  failed: 'Failed',
  avgTime: 'Average training time',
  avgScore: 'Avg. score',
  avgScoreHeader: 'Avg. score',
  selectCourse: 'Select course...',
  unassigned: 'Unassigned',
  export: 'Export',
  sortBy: 'Sort by name (A-Z)',
  overallScore: 'Overall score',
  noData: 'It looks like you’re just getting started.',
  noDataInfo1: 'As learners interact with your content,',
  noDataInfo2:
    'this page will fill with performance stats and engagement data.',
  learner: 'Learner',
  status: 'Status',
  duration: 'Duration',
  score: 'Score',
  progress: 'Progress',
  analytics: 'Analytics',
  back: 'Back',
  passingScore: 'Passing score',
  learners: 'Learners',
  lesson: 'Lesson',
  participatory: 'Participatory',
  dueDate: 'Due date',
  noDueDate: 'No due date',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  author: 'Author',
  comment: 'Comment',
  date: 'Date',
  microreel: 'Microreel',
  otherComments: 'Other comments',
  noComments: 'No comments at the moment',
  commentsCount: (count: number) =>
    `${count} ${count === 1 ? 'comment' : 'comments'}`,
  repliesCount: (count: number) =>
    `${count} ${count === 1 ? 'reply' : 'replies'}`,
  likes: 'Likes',
  noLikes: 'No likes at the moment',
  totalLikes: (count: number) =>
    `${count} total ${count === 1 ? 'like' : 'likes'}`,
  totalLessonsCompletedTitle: 'Total lessons completed',
  totalLikesTitle: 'Total likes',
  totalCommentsTitle: 'Total comments',
};
